import 'kezzler-app-design/src/style/global.scss'
import 'kezzler-app-design/src/style/style.scss'
import Vue from 'vue'
import miniToastr from 'mini-toastr'

import SspLayout from '@/components/layout/SspLayout'
import ConfirmDialog from '@/plugins/ConfirmDialog'

import './require.css'
import './styles/main.scss'
import './components/global/register-globals'
import 'bootstrap';
import App from './App'
import router from './router'
import auth from './service/AuthService'

function hide(element, cb) {
  if (element.parentNode) {
    element.parentNode.removeChild(element)
    if (cb) {
      cb()
    }
  }
}

miniToastr.init({ timeout: 3000, animation: hide })

Vue.directive('visibleFor', (elem, b) => {
  const el = elem
  if (auth.isAdmin()) {
    return
  }

  if (b.value.some((r) => auth.hasRole(r))) {
    return
  }
  el.style.display = 'none'
})

Vue.component('SspLayout', SspLayout)

Vue.use(ConfirmDialog)

new Vue({
  el: '#app',
  router,
  render: (h) => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js